import { queryOptions } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";

export const useAdvertisementHistory = (advertisementId: number, days: number | undefined, entityTypes: string[]) => {
  return queryOptions({
    queryKey: [{ entity: "advertisementHistory", advertisementId, days, entityTypes }],
    queryFn: async () =>
      await apiClient.getAdvertisementHistory({
        params: { advertisement_id: advertisementId },
        queries: { days, n: 1000, entity_types: entityTypes.join(",") },
      }),
    enabled: !!advertisementId && entityTypes.length > 0,
  });
};
